import { api } from './api';
import { apiConfig } from './config';

export const accountApi = {
    userInfo: () => api.directCall('post', `${apiConfig.accountUrl}/user-info`),

    login: (data: any) => api.directCall('post', apiConfig.accountUrl + '/login', data),

    register: (data: any) => api.directCall('post', apiConfig.accountUrl + '/register', data),

    //authenticateRegister: (data) => api.directCall("post", apiConfig.accountUrl + "/authenticate-register", data),

    initUserProfile: () => api.call('post', apiConfig.accountUrl + '/init-user-profile'),

    updateUserProfile: (user: any) =>
        api.call('post', apiConfig.accountUrl + '/update-user-profile', user),
    changeUserPassword: (data: any) =>
        api.call('post', apiConfig.accountUrl + '/change-user-password', data),
    changeUserPhoneNumber: (data: any) =>
        api.call('post', apiConfig.accountUrl + '/change-user-phone-number', data),

    // terminateOtherUserSession: (sessions) => api.call("delete", apiConfig.accountUrl + "/terminate-sessions", sessions),

    logout: () => api.directCall('post', apiConfig.accountUrl + '/logout'),

    getRegistrationRequests: (data: any) =>
        api.call('post', apiConfig.accountUrl + `/get-registration-requests`, data),

    getUserDevices: () => api.call('post', apiConfig.accountUrl + `/get-user-devices`),

    updateUserDevices: (id: any) =>
        api.call('post', apiConfig.accountUrl + `/update-user-device?id=${id}`),
};
